const styles = (theme) => ({
  root: {
    textTransform: 'none',
    letterSpacing: 0.16,
    fontSize: 16,
    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'underline',
    },
  },
  label: {},
  underline: {
    lineHeight: 1.43,
    letterSpacing: 1.25,
    padding: 0,
    minWidth: 0,
    borderBottom: `2px solid ${theme.color.teal}`,
  },
});

export default styles;
